import { apiRequest } from '@/lib/api-client';
import type { LoginResponse, PublicUser, SessionSummary } from './types';

const BASE = '/api/v1/auth';

export const authApi = {
  register: (body: { email: string; password: string; name: string }) =>
    apiRequest<{ message: string }>(`${BASE}/register`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  login: (body: { email: string; password: string }) =>
    apiRequest<LoginResponse>(`${BASE}/login`, { method: 'POST', body, skipAuthRefresh: true }),

  verifyTwoFactor: (body: { challengeToken: string; code: string }) =>
    apiRequest<{ user: PublicUser }>(`${BASE}/2fa/verify`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  verifyEmail: (body: { token: string }) =>
    apiRequest<{ verified: boolean }>(`${BASE}/verify-email`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  resendVerification: (body: { email: string }) =>
    apiRequest<{ message: string }>(`${BASE}/resend-verification`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  forgotPassword: (body: { email: string }) =>
    apiRequest<{ message: string }>(`${BASE}/forgot-password`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  resetPassword: (body: { token: string; password: string }) =>
    apiRequest<{ reset: boolean }>(`${BASE}/reset-password`, {
      method: 'POST',
      body,
      skipAuthRefresh: true,
    }),

  // No skipAuthRefresh: on app load an expired access token is silently
  // refreshed from the refresh cookie so the session resumes.
  me: () => apiRequest<PublicUser>(`${BASE}/me`),

  logout: () => apiRequest<{ loggedOut: boolean }>(`${BASE}/logout`, { method: 'POST' }),

  logoutAll: () => apiRequest<{ loggedOut: boolean }>(`${BASE}/logout-all`, { method: 'POST' }),

  listSessions: () => apiRequest<SessionSummary[]>(`${BASE}/sessions`),

  revokeSession: (id: string) =>
    apiRequest<{ revoked: boolean }>(`${BASE}/sessions/${id}`, { method: 'DELETE' }),

  enableTwoFactor: () => apiRequest<PublicUser>(`${BASE}/2fa/enable`, { method: 'POST' }),

  disableTwoFactor: (body: { password: string }) =>
    apiRequest<PublicUser>(`${BASE}/2fa/disable`, { method: 'POST', body }),

  beginTotpSetup: () =>
    apiRequest<{ secret: string; keyUri: string }>(`${BASE}/2fa/totp/setup`, { method: 'POST' }),
  confirmTotpSetup: (code: string) =>
    apiRequest<{ user: PublicUser; backupCodes: string[] }>(`${BASE}/2fa/totp/confirm`, {
      method: 'POST',
      body: { code },
    }),
  regenerateBackupCodes: () =>
    apiRequest<{ backupCodes: string[] }>(`${BASE}/2fa/backup-codes`, { method: 'POST' }),
};
